var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Homenav'),_c('Home'),_c('Methodology'),_c('Benefits'),_c('Curriculum'),_c('Subscribe'),_c('Homefooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }